import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { themeVal } from '@devseed-ui/theme-provider';

export const LinkHoverLine = () => css`
  position: relative;
  transition: all 0.16s ease-in-out;
  background: linear-gradient(
    to bottom,
    ${themeVal('color.primary-500')} 0%,
    ${themeVal('color.primary-500')} 99%
  );
  background-size: 100% 12%;
  background-repeat: no-repeat;
  background-position: left 100%;
  &:hover {
    opacity: 1;
    background-size: 100% 64%;
  }
`;

export const StyledLink = styled(Link)`
  position: relative;
  &:hover {
    color: ${themeVal('color.primary')};
  }
  ${LinkHoverLine}
`;
